export default __webpack_public_path__ + "img/screenshot_2.e7082c7e.png";